import { Mention } from './Mention';
import type { handleMentionKeyEventType } from './types';
import { withMentions } from './utils';

type MentionPluginProps =
  | {
      [props: string]: unknown;
      className?: string;
      handleMentionKeyEvent?: handleMentionKeyEventType;
    }
  | Record<string, never>;

const MentionPlugin = ({
  className = '',
  handleMentionKeyEvent = () => {},
  ...attributes
}: MentionPluginProps = {}) => ({
  renderElement: Mention({ className, ...attributes }),
  with: withMentions,
  onKeyDown: handleMentionKeyEvent,
});

export { MentionPlugin };
